const generateRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
export const mockAsyncRequest = success => new Promise(resolve => {
  const timeout = generateRandomNumber(100, 200);
  setTimeout(() => {
    resolve(success());
  }, timeout);
});